import React from 'react';
import { Skeleton, Box } from '@mui/material';

const DataGridSkeleton = ({ height = 400, rowsNum = 10 }) => {
  return (
    <Box sx={{ width: '100%', height: height }}>
      {/* Header */}
      <Box sx={{ display: 'flex', mb: 0.5 }}>
        {[...Array(5)].map((_, index) => (
          <Box key={index} sx={{ flex: 1, mx: 0.5 }}>
            <Skeleton animation="wave" height={48} />
          </Box>
        ))}
      </Box>
      
      {/* Rows */}
      {[...Array(rowsNum)].map((_, index) => (
        <Box key={index} sx={{ display: 'flex', mb: 0.5 }}>
          {[...Array(5)].map((_, colIndex) => (
            <Box key={colIndex} sx={{ flex: 1, mx: 0.5 }}>
              <Skeleton animation="wave" height={30} />
            </Box>
          ))}
        </Box>
      ))}
      
      {/* Pagination */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Skeleton animation="wave" height={30} width={300} />
      </Box>
    </Box>
  );
};

export default DataGridSkeleton; 